import React from "react";
import styles from "../styles/menus-evento.module.css";
import { FaMagnifyingGlass } from "react-icons/fa6";
import EventoCard from "./EventoCard";

export default function EventosMenusList({
    eventos,
    isEventOpen,
    onToggleEvent,
    isMenuOpen,
    onToggleMenu,
}) {
    if (!eventos.length) {
        return (
            <div className={styles.empty}>
                <h3><FaMagnifyingGlass style={{ fontSize: "30px" }} /></h3>
                <p>Prueba cambiando las fechas o el término de búsqueda.</p>
            </div>
        );
    }

    return (
        <div className={styles["event-grid"]}>
            {eventos.map((ev) => (
                <EventoCard
                    key={ev.id}
                    ev={ev}
                    open={isEventOpen(ev.id)}
                    onToggleEvent={() => onToggleEvent(ev.id)}
                    isMenuOpen={isMenuOpen}
                    onToggleMenu={onToggleMenu}
                />
            ))}
        </div>
    );
}
